/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import cn from 'classnames';
import dayjs from 'dayjs';
import styled from 'styled-components';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { PageHeader } from '../../../../app/components/PageHeader';
import CardComponent from '../../../containers/App/Components/Card/Card';
import LoadingCard from '../../../containers/App/Components/LoadingCard/LoadingCard';
import PaginationComponent from '../../../containers/App/Components/Pagination/Pagination';
import { ArrowDown, Right, ChevronRight, Home, Sort, Euro, Car } from '../../../components/Icon';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';
import { TransportOrderSearch } from '../components/Search';
import { RegplateLabel } from '../../Vehicles/components/RegplateLabel';
import { VehicleStatusLabel } from '../../Vehicles/components/VehicleStatusLabel';
import { HBox, VBox } from '../../../components/Box';
import { getDate, getVehicleTaskOpen } from '../../Vehicles/helpers';
import { WithVehicle } from '../../Vehicles/components/WithVehicle';
import LoadingFilters from '../../../containers/App/Components/LoadingFilters/LoadingFilters';

import {
  addTransportOrderToBulkActionsList,
  applyTransportOrderFilters,
  changeTransportOrderFilter,
  removeTransportOrderFromBulkActionsList,
  setTransportOrdersSort,
  switchOverviewScreenMode,
} from '../actions';
import { setScrollPosition } from '../../Actions/actions';
import { toggleNotification } from '../../Companies/actions';

import {
  selectOverviewScreenMode,
  selectTransportOrderCount,
  selectTransportOrderFilter,
  selectTransportOrderPaginator,
  selectTransportOrders,
  selectTransportOrdersBulkActionsList,
} from '../selectors';
import { selectWorks } from '../../Api/selectors';
import { REQUEST_TRANSPORT_ORDERS, SET_TRANSPORT_ORDERS_SORT } from '../constants';
import s from './overview.module.css';
import { BulkActionsTransportOrderCard } from './BulkActions/BulkActionsCard';
import { transportOrdersSearch } from './../actions';
import { Button } from '../../../components/Buttons';
import { TransportOrderCreateModal } from '../components/createTransportOrder';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import { TransportOrdersOverviewMaps } from './overviewMaps';
import { parseCompanyPhoneNumber } from '../helpers';
import { OnMouseOverNotification } from '../../Vehicles/components/OnMouseOverNotification';
import { Label } from '../../Vehicles/components/VehicleCounterLabel';
import { HomeAddressLabel } from '../../Vehicles/components/HomeAddressesIconLabel';

dayjs.extend(customParseFormat);

const RemarkDataIconWrapper = styled.div`
  a {
    position: relative;
  }

  .alt-block {
    position: absolute;
    left: 100px;
    margin-left: -400px;
    margin-top: 15px;
    top: ${props => (props.innerWidth < 768 ? '110%' : '100%')};
    z-index: 2;
    min-width: ${props => (props.innerWidth < 768 ? '150px' : '250px')};
    max-width: ${props => (props.innerWidth < 768 ? '150px' : '300px')};
    padding: 4px 8px;
    background-color: #cccccc;
    color: #6d727b;
    white-space: normal;
    text-align: left;
    border-radius: 5px;
  }
`;

const STATE = {
  sort: null,
  sort_direction: 'down',
  isShowAddModal: false,
  isShowMore: true,
  currentPage: 0,
  localPaginator: {
    limit: 50,
    offset: 0,
    itemsCount: 0,
  },
  filteredVehicles: [],
};

const ranges = {
  MediumSeaGreen: [2, 4],
  DarkOrange: [5, 7],
  Crimson: [8, Infinity],
};

/* eslint-disable react/prefer-stateless-function */
class TransportOrdersOverviewComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
      isTableView: true, // Default to table view
      showModal: false, // New state to manage modal visibility
      selectedTransportOrder: null, // Store the selected transport order
    });
  }

  toggleView = () => {
    this.setState(prevState => ({
      isTableView: !prevState.isTableView,
    }));
  };

  toggleSplitScreen = () => {
    this.setState(prevState => ({
      isSplitScreen: !prevState.isSplitScreen,
    }));
  };

  componentDidMount() {
    this.setState({ showModal: false, selectedTransportOrder: null });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.transportOrders !== this.props.transportOrders) {
      // Reset modal state when transport orders update (e.g., after search)
      this.setState({ showModal: false, selectedTransportOrder: null });
    }
  }

  get transportOrders() {
    return this.props.transportOrders;
  }

  get isShowDeletedStatusItems() {
    const canceled = this.props.filter?.properties?.find(p => p.key === 'status')?.value?.includes('canceled');
    const done = this.props.filter?.properties?.find(p => p.key === 'status')?.value?.includes('done');

    if (done) return 'canceled';
    if (canceled) return 'done';

    return null;
  }

  get locationState() {
    return this.props.location?.state?.state;
  }

  get noSortingTypes() {
    return ['isHome', 'regplate', 'from_address', 'to_address', 'from_company', 'to_company', 'transporter', 'type'];
  }

  renderVehiclePaymentStatusSplit(type, vehicle) {
    if (type === 'incoming') {
      return vehicle.incoming_invoice_payment_status ? (
        <span style={{ color: 'green' }}>
          <Euro />
        </span>
      ) : (
        !vehicle.incoming_invoice_payment_status && (
          <span style={{ color: 'red' }}>
            <Euro />
          </span>
        )
      );
    }
    if (type === 'outgoing') {
      return vehicle.outgoing_invoice_payment_status == 'PAID' ? (
        <span style={{ color: 'green' }}>
          <Euro />
        </span>
      ) : vehicle.outgoing_invoice_payment_status == 'PARTLY_PAID' ? (
        <span style={{ color: 'black' }}>
          <Euro />
        </span>
      ) : (
        <span style={{ color: 'red' }}>
          <Euro />
        </span>
      );
    }

    return '';
  }
  renderReleaseStatusSplit(type, vehicle) {
    if (type === 'incoming') {
      return vehicle.regplate && vehicle.orb_incoming_complete ? (
        <span style={{ color: 'green' }}>
          <Car />
        </span>
      ) : (
        vehicle.regplate && !vehicle.orb_incoming_complete && (
          <span style={{ color: 'red' }}>
            <Car />
          </span>
        )
      );

      // <VehicleStatusLabel width={'80px'} color={vehicle?.orb_incoming_complete ? '#15AC79' : 'red'} overview={'double'}>
      //   {vehicle?.orb_incoming_complete ? 'Vrijwaring' : 'Vrijwaring'}
      // </VehicleStatusLabel>
    }
    return '';
  }

  renderVehiclePaymentStatus(type, vehicle) {
    if (type === 'incoming') {
      return (
        <VehicleStatusLabel color={vehicle?.incoming_invoice_payment_status ? '#15AC79' : 'red'} width={'80px'}>
          {vehicle?.incoming_invoice_payment_status ? 'Betaling' : 'Betaling'}
        </VehicleStatusLabel>
      );
    }
    if (type === 'outgoing') {
      return (
        <VehicleStatusLabel
          width={'80px'}
          color={
            vehicle?.outgoing_invoice_payment_status === 'PAID'
              ? '#15AC79'
              : vehicle?.outgoing_invoice_payment_status === 'PARTLY_PAID'
              ? 'black'
              : 'red'
          }
        >
          {vehicle?.outgoing_invoice_payment_status === 'PAID'
            ? 'Betaling'
            : vehicle?.outgoing_invoice_payment_status === 'PARTLY_PAID'
            ? 'Betaling'
            : 'Betaling'}
        </VehicleStatusLabel>
      );
    }

    return '';
  }
  renderReleaseStatus(type, vehicle) {
    if (type === 'incoming') {
      return (
        <VehicleStatusLabel width={'80px'} color={vehicle?.orb_incoming_complete ? '#15AC79' : 'red'}>
          {vehicle?.orb_incoming_complete ? 'Vrijwaring' : 'Vrijwaring'}
        </VehicleStatusLabel>
      );
    }
    return '';
  }

  getTypesTosort(type) {
    let types = {
      info: 'model_name',
    };

    return types[type] || type;
  }

  sortOn(field) {
    if (this.noSortingTypes?.includes(field)) {
      return;
    }

    let direction = 'none';
    let sortType;

    switch (field) {
      case 'info': {
        sortType = 'model_name';
        break;
      }

      default:
        sortType = field;
    }

    let order;
    if (this.props.filter?.sortType == sortType) {
      if (!this.props.filter?.order) order = 'asc';
      if (this.props.filter?.order == 'asc') order = 'desc';
    } else {
      order = 'asc';
    }
    this.setState({ direction: !order ? 'none' : order == 'asc' ? 'up' : 'down' });
    order ? this.props.setSort(sortType, order) : this.props.setSort('', '');
  }

  selectPage = newPage => {
    const newOffset = newPage * this.props.paginator?.limit ?? 0;
    this.props.setScrollPosition(null);

    this.setState(
      prev => ({
        currentPage: newPage,
      }),
      this.props.changeFilter('offset', newOffset),
    );
  };

  cols() {
    if (this.state.isSplitScreen) {
      return ['info', 'financial_info', 'from_company', 'to_company', 'dateToPlan', 'direction', 'type'];
    }
    return [
      'regplate',
      'info',
      'from_company',
      'from_address',
      'to_company',
      'to_address',
      'plan',
      'transporter',
      'datePlanned',
      'dateToPlan',
      'type',
     
    ];
  }

  colsSplit() {
    return [
      // 'regplate',

      'info',
      'financial_info',
      'from_company',

      // 'from_address',
      'to_company',
      // 'to_address',
      // 'transporter',
      //'datePlanned',
      'dateToPlan',
      'direction',
      'type',
      //'plan',
    ];
  }

  toggleDiv = () => {
    this.setState(prevState => ({
      isShowMore: !prevState.isShowMore,
    }));
  };

  isHovered(hoveredOption, transportOrderId) {
    this.setState({ isHover: hoveredOption, hoveredId: transportOrderId });
  }

  renderOpennedTaskAlert(vehicle) {
    if (getVehicleTaskOpen(vehicle)?.length) {
      return (
        <OnMouseOverNotification
          message={
            <div className="d-flex flex-column gap-2">
              <span className="red-text">{this.lbl('kanbanboards.cell.has_open_task')}: </span>
              <span>{this.lbl('vehicle.property.' + getVehicleTaskOpen(vehicle)[0])}</span>
            </div>
          }
          minWidth={'250px'}
          left={'0px'}
        />
      );
    }
    return null;
  }

  dateDifference(transportOrder) {
    const createdDate = transportOrder?.createdAt;
    if (!createdDate) return 0;

    const now = dayjs();
    const created = dayjs(createdDate);
    const diff = now.diff(created, 'day');

    return diff;
  }

  renderRemarkText(remarks, transportOrderId) {
    if (!remarks?.length) {
      return (
        <img
          style={{ cursor: 'pointer', opacity: '0.15', marginRight: '5px' }}
          src="https://vindat.indewal.nl/storage/documents/ca10dd49-aac5-4351-a014-a3cfeee9f88d.png"
          title=""
          width="18"
        />
      );
    }

    let parsedRemarks = remarks;
    return (
      <RemarkDataIconWrapper innerWidth={window.innerWidth}>
        <a
          onMouseEnter={() => this.isHovered('hoveredRemarks', transportOrderId)}
          onMouseLeave={() => this.isHovered(false)}
        >
          <img
            className="data-remark-image"
            style={{ cursor: 'pointer', marginRight: '5px' }}
            src="https://vindat.indewal.nl/storage/documents/ca10dd49-aac5-4351-a014-a3cfeee9f88d.png"
            width="18"
          />
          {this.state.isHover === 'hoveredRemarks' && this.state.hoveredId === transportOrderId && (
            <div className="alt-block">
              <strong style={{ display: 'block' }}>{`${parsedRemarks}\n`}</strong>
            </div>
          )}
        </a>
      </RemarkDataIconWrapper>
    );
  }

  isSelectedTransportOrder(transportOrderId) {
    return this.props.bulkActionsList?.filter(item => item?.id === transportOrderId)?.length == 1;
  }

  onSelectTransportOrder(e, transportOrder) {
    e.stopPropagation();

    if (this.isSelectedTransportOrder(transportOrder?.id)) {
      return this.props.removeTransportOrderFromBulkActionsList(transportOrder?.id);
    }
    console.log('transportOrder', transportOrder);
    return this.props.addTransportOrderToBulkActionsList(transportOrder);
  }

  onSelectAll(e, transportOrders) {
    e.stopPropagation();
    return transportOrders?.filter(transportOrder => this.props.addTransportOrderToBulkActionsList(transportOrder));
  }

  onRemoveAll(e, transportOrders) {
    e.stopPropagation();
    return transportOrders?.filter(transportOrder => this.props.removeTransportOrderFromBulkActionsList(transportOrder?.id));
  }

  renderCellSplit(col, transportOrder) {
    const establishmentName = "In de Wal Auto's B.V.";
    const vehicle = transportOrder?.vehicle;
    const fromCompany = transportOrder?.companyFrom;
    const fromAddress = transportOrder?.addressFrom;
    const toCompany = transportOrder?.companyTo;
    const toAddress = transportOrder?.addressTo;
    const transporter = transportOrder?.transporter;

    const key = `${col}-${transportOrder.id}`;

    const fn = () => {
      switch (col) {
        case 'regplate':
          if (transportOrder?.vehicleManual) {
            return '-';
          }
          return (
            <div className={cn('text-wrap', s.reglateCarSplit)} key={key}>
              {vehicle?.regplate ? (
                <div className={s.licensePlateSplit}>
                  <a href={`/vehicles/${vehicle?.id}`} target="_blank" rel="noopener noreferrer">
                    <RegplateLabel regplate={vehicle?.regplate} width="80" />
                  </a>
                </div>
              ) : (
                <a href={`/vehicles/${vehicle?.id}`} target="_blank" rel="noopener noreferrer">
                  <div>{vehicle.vin?.substr(-6)}</div>
                </a>
              )}

              {/* <div>ID: {vehicle.id}</div> */}
            </div>
          );

        case 'info':
          if (transportOrder?.vehicleManual) {
            return <div className={s.brandNameSplit}>{transportOrder?.vehicleManual}</div>;
          }
          return (
            <>
              <div className={cn('text-wrap', s.reglateCarSplit)} key={`${key}-col-info`}>
                {vehicle?.regplate ? (
                  <div className={s.licensePlateSplit}>
                    <a href={`/vehicles/${vehicle?.id}`} target="_blank" rel="noopener noreferrer">
                      <RegplateLabel regplate={vehicle?.regplate} width="80" />
                    </a>
                  </div>
                ) : (
                  <a href={`/vehicles/${vehicle?.id}`} target="_blank" rel="noopener noreferrer">
                    <div>{vehicle.vin?.substr(-6)}</div>
                  </a>
                )}

                {/* <div>ID: {vehicle.id}</div> */}
              </div>
              <div key={key} className={s.gridContainerSplit}>
                <div className={s.carInformationSplit}>
                  <WithVehicle vehicle_id={transportOrder?.vehicleId}>
                    <div className={s.modelInfoSplit}>
                      {vehicle.brand_name} {vehicle.model_name?.substring(0, 17)}
                    </div>
                    <div className={s.modelNameSplit}></div>
                  </WithVehicle>
                  <div className="d-flex align-items-center" style={{ gap: '5px' }}></div>
                </div>
              </div>
            </>
          );
          break;

        case 'financial_info':
          return (
            <VBox className={s.modelInfoSplit} gap={'4px'}>
              {this.renderVehiclePaymentStatusSplit(transportOrder?.type, vehicle)}
              {this.renderReleaseStatusSplit(transportOrder?.type, vehicle)}
            </VBox>
          );

        case 'from_company':
          return (
            <VBox left>
              <VBox className={cn(s.addressSplit)} left>
                <strong>
                  {transportOrder?.companyFromManual ||
                    (fromCompany?.['company_type'] === 'company'
                      ? fromCompany?.['name']?.substring(0, 33) || ''
                      : `${fromCompany?.name?.substring(0, 33) || ''} ${fromCompany?.surname?.substring(0, 33) || ''}`)}
                  <br />
                </strong>
                {`${fromAddress?.addressLine1?.substring(0, 17) || ''}, ${fromAddress?.city || ''}`}
              </VBox>
            </VBox>
          );
        case 'from_address':
          if (transportOrder?.addressFromManual) {
            return <>{transportOrder?.addressFromManual}</>;
          }
          return (
            <VBox left>
              <VBox className={cn(s.addressSplit)} left>
                <strong>{fromAddress?.addressLine1}</strong>
                <VBox className={cn(s.addressSplit)}>
                  {fromAddress?.postcode} {fromAddress?.city}
                </VBox>
                <VBox className={cn(s.addressSplit)}>{fromAddress?.country?.name}</VBox>
                <VBox className={cn(s.addressSplit)}>{parseCompanyPhoneNumber(fromCompany)}</VBox>
              </VBox>
            </VBox>
          );
        case 'to_company':
          return (
            <>
              <VBox left>
                <VBox className={cn(s.addressSplit)} left>
                  <strong>
                    {transportOrder?.companyToManual ||
                      (toCompany?.['company_type'] === 'company'
                        ? toCompany?.['name']?.substring(0, 33) || ''
                        : `${toCompany?.name?.substring(0, 33) || ''} ${toCompany?.surname?.substring(0, 33) || ''}`)}
                    <br />
                  </strong>
                  {`${toAddress?.addressLine1?.substring(0, 17) || ''}, ${toAddress?.city || ''}`}
                </VBox>
              </VBox>
            </>
          );
        case 'to_address':
          if (transportOrder?.addressToManual) {
            return <>{transportOrder?.addressToManual}</>;
          }
          return null;
        case 'transporter':
          return (
            <>
              <VBox className={cn(s.addressSplit)} left>{`${transporter?.name || ''}`}</VBox>
            </>
          );
        case 'datePlanned':
          return (
            <VBox gap={8}>
              <VBox className={cn(s.addressSplit)} left>
                {getDate(transportOrder.datePlanned)}
              </VBox>
            </VBox>
          );
        case 'dateToPlan':
          return (
            <VBox gap={8}>
              <VBox className={cn(s.addressSplit)} left>
                {getDate(transportOrder.dateToPlan)}
              </VBox>
            </VBox>
          );

        case 'direction':
          return (
            <VBox gap={2} className={cn(s.addressSplit)} left>
              <VehicleStatusLabel
                key={`${col}-${transportOrder.id}-${transportOrder.id}`}
                status={transportOrder?.type}
                overview={'double'}
              >
                {transportOrder?.type}
              </VehicleStatusLabel>
            </VBox>
          );

        case 'type':
          return (
            <>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
                <VBox gap={2} className={cn(s.addressSplit)} left>
                  <VehicleStatusLabel
                    key={`${col}-${transportOrder.id}-${col}`}
                    status={transportOrder?.status}
                    overview={'double'}
                  >
                    {this.lbl(`transport_order.filter.${transportOrder?.status}`)}
                  </VehicleStatusLabel>
                </VBox>

                {transporter?.name && (
                  <VBox gap={2} className={cn(s.addressSplit)} center>
                    <VehicleStatusLabel
                      key={`${col}-${transportOrder.id}-${col}`}
                      status={transporter?.name}
                      overview={'double'}
                      color={'black'}
                    >
                      {this.lbl(`transport_order.filter.${transporter?.name}`)}
                    </VehicleStatusLabel>
                    {transportOrder?.datePlanned ? new Date(transportOrder.datePlanned).toLocaleDateString('nl-NL') : ''}
                  </VBox>
                )}
              </div>
            </>
          );

        case 'plan':
          return (
            // <>
            //   <VBox gap={8} onClick={event => event.stopPropagation()} key={`${col}-${transportOrder.id}`}>
            //     <TransportOrderCreateModal
            //       vehicle={transportOrder?.vehicle}
            //       transportOrderId={transportOrder?.id}
            //       overviewButton={true}
            //     />
            //   </VBox>
            // </>
            null
          );

        default:
          return vehicle[col];
      }
    };
    return (
      <div className={`col-${col}`} key={`${col}-${transportOrder.id}`}>
        {fn()}
      </div>
    );
  }

  renderRowSplit(transportOrder, screen) {
    return (
      <tr
        className={`align-middle ${s.theadFirstScreenSplit}`}
        key={transportOrder.id}
        id={`item${transportOrder.id}`}
        onClick={event => this.handleTableRowClick(event, transportOrder)}
      >
        <td className={s.bodyTdSplit}>
          <div className={s.checkboxContainerTdSplit}>
            <CheckboxComponent
              disabled={this.props.weblogin}
              checked={this.isSelectedTransportOrder(transportOrder?.id)}
              onChange={e => this.onSelectTransportOrder(e, transportOrder)}
            />
          </div>
        </td>

        {this.colsSplit().map(col => (
          <td className={s.bodyTdSplit}>{this.renderCellSplit(col, transportOrder)}</td>
        ))}
      </tr>
    );
  }

  renderHeaderCellSplit(col) {
    switch (col) {
      case 'isHome':
        return '';
      default:
        return this.lbl(`transport_order.overview.column.${col}`);
    }
  }

  filterTransportOrders = filterParams => {
    if (!filterParams) {
      this.setState({ filteredTransportOrders: this.props.webloginVehicles || [] });
      return;
    }

    const filters = filterParams.properties.reduce((acc, cur) => {
      if (cur.key === 'status') {
        acc[cur.key] = cur.value;
      } else {
        acc[cur.key] = cur.value.map(v => v.toLowerCase());
      }
      return acc;
    }, {});

    const searchString = filterParams.searchString ? filterParams.searchString.toLowerCase() : '';
    const searchWords = searchString.split(/\s+/);

    if (!this.props.webloginVehicles) {
      this.setState({ filteredVehicles: [] });
      return;
    }

    const filteredVehicles = this.props.webloginVehicles.filter(vehicle => {
      const vehicleStatus = vehicle.status;

      const matchesFilters = Object.keys(filters).every(key => {
        if (key === 'status') {
          return filters[key].length === 0 || filters[key].includes(vehicleStatus);
        } else {
          const vehicleProperty = vehicle[key] ? vehicle[key].toLowerCase() : '';
          return filters[key].length === 0 || filters[key].some(filterValue => vehicleProperty.includes(filterValue));
        }
      });

      const matchesSearchString =
        searchWords.length === 0 ||
        searchWords.every(word =>
          ['brand_name', 'model_name', 'id', 'regplate', 'vin'].some(prop =>
            vehicle[prop]
              ? vehicle[prop]
                  .toString()
                  .toLowerCase()
                  .includes(word)
              : false,
          ),
        );

      return matchesFilters && matchesSearchString;
    });

    this.setState({ filteredVehicles });
  };

  render() {
    if (this.props.work)
      return (
        <>
          <PageHeader
            title={
              <>
                <Home />
                {this.lbl('transport_order.overview.title')}
                {this.props.count !== null ? <span className="label number">{this.props.count}</span> : null}
              </>
            }
            breadCrumbs={
              <>
                <a href="/">Vindat</a>
                <ChevronRight />
                {this.lbl('transport_order.overview.title')}
              </>
            }
          />
          <LoadingFilters />
        </>
      );

    const transportOrders = this.transportOrders;
    const { localPaginator } = this.state;
    const {
      currentPage,
      localPaginator: { limit },
    } = this.state;

    const transportOrdersToShow = transportOrders;

    return (
      <div className="container-fluid p-0">
        {!!this.props.bulkActionsList?.length && (
          <BulkActionsTransportOrderCard bulkActionsList={this.props.bulkActionsList} />
        )}
        <PageHeader
          title={
            <>
              <Home />
              {this.lbl('transport_order.overview.title')}
              {this.props.count !== null ? <span className="label number">{this.props.count}</span> : null}
            </>
          }
          breadCrumbs={
            <>
              <a href="/">Vindat</a>
              <ChevronRight />
              {this.lbl('transport_order.overview.title')}
            </>
          }
        ></PageHeader>

        <div className="container-fluid p-0">
          <HBox right style={{ gap: '10px' }}>
            {' '}
            {window.innerWidth >= 768 && (
              <>
                <ButtonComponent style={'ButtonSoftPrimary'} onClick={() => this.props.switchScreen()}>
                  {this.props.doubleScreen ? this.lbl('transport.single') : this.lbl('transport.double')}
                </ButtonComponent>
                <ButtonComponent style={'ButtonSoftPrimary'} onClick={this.toggleView}>
                  {this.state.isTableView ? this.lbl('transport.show_card') : this.lbl('transport.show_column')}
                </ButtonComponent>
                <ButtonComponent style={'ButtonSoftPrimary'} onClick={this.toggleSplitScreen}>
                  {this.state.isSplitScreen ? this.lbl('transport.single_screen') : this.lbl('transport.split_screen')}
                </ButtonComponent>
              </>
            )}
          </HBox>
          <TransportOrderSearch />
        </div>

        {window.innerWidth >= 1024 && this.props.count !== (null || 0) && !this.state.isTableView && (
          <TransportOrdersOverviewMaps />
        )}

        {this.state.isTableView &&
          (window.innerWidth >= 1024 && this.props.count !== (null || 0) ? (
            <div className="d-flex gap-2">
              {this.state.isSplitScreen && (
                <tr className={cn('align-middle', s.theadMapsScreen)}>
                  <TransportOrdersOverviewMaps />
                </tr>
              )}

              {this.state.isSplitScreen ? (
                <table className={cn('table', 'table-hover', 'mb-0', s.wrapperSplit)}>
                  <thead className="align-middle">
                    <tr className={cn('align-middle', s.theadFirstScreenSplit)}>
                      <th className={s.headThSplit}>
                        <CheckboxComponent
                          disabled={this.props.weblogin}
                          checked={this.state.allSelected == '1'}
                          onChange={e => {
                            if (this.state.allSelected == '1') {
                              this.setState({ allSelected: '0' });
                              return this.onRemoveAll(e, [...this.props.transportOrders, ...transportOrdersSecondList]);
                            }
                            this.setState({ allSelected: '1' });
                            return this.onSelectAll(e, [...this.props.transportOrders, ...transportOrdersSecondList]);
                          }}
                        />
                      </th>
                      {this.colsSplit().map((col, index) => (
                        <th className={s.headThSplit} key={`${col}-${index}`} onClick={() => this.sortOn(col)}>
                          <div className={cn('d-flex gap-2 text-muted', s.spanContainerSplit)}>
                            {col != 'financial_info' &&
                              col != 'transporter' &&
                              col != 'direction' &&
                              this.renderHeaderCellSplit(col)}

                            {!this.noSortingTypes?.includes(col) && (
                              <Sort
                                direction={
                                  this.getTypesTosort(this.props.filter?.sortType) == col ? this.state.direction : 'none'
                                }
                              />
                            )}
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {transportOrdersToShow.filter(t => t).map(transportOrder => this.renderRowSplit(transportOrder, '1'))}
                    {!!this.props.transportOrders?.length && this.props.paginator?.itemsCount > this.props.paginator?.limit && (
                      <div className="d-flex justify-content-center mt-2 mb-5 mb-md-0">
                        <PaginationComponent paginator={this.props.paginator} selectPage={this.selectPage} />
                      </div>
                    )}
                  </tbody>
                </table>
              ) : (
                <table className={cn('table', 'table-hover', 'mb-0', s.wrapper)}>
                  <thead className={cn('align-middle', { [s.theadFirstScreen]: this.state.isSplitScreen })}>
                    <tr className={cn('align-middle', s.thead)}>
                      <th className={s.headTh}>
                        <CheckboxComponent
                          disabled={this.props.weblogin}
                          checked={this.state.allSelected == '1'}
                          onChange={e => {
                            if (this.state.allSelected == '1') {
                              this.setState({ allSelected: '0' });
                              return this.onRemoveAll(e, this.props.transportOrders);
                            }
                            this.setState({ allSelected: '1' });
                            return this.onSelectAll(e, this.props.transportOrders);
                          }}
                        />
                      </th>
                      {this.cols().map((col, index) => (
                        <th className={s.headTh} key={`${col}-${index}`} onClick={() => this.sortOn(col)}>
                          <div className={cn('d-flex gap-2 text-muted', s.spanContainer)}>
                            {this.renderHeaderCell(col)}
                            {!this.noSortingTypes?.includes(col) && (
                              <Sort
                                direction={
                                  this.getTypesTosort(this.props.filter?.sortType) == col ? this.state.direction : 'none'
                                }
                              />
                            )}
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {transportOrdersToShow.filter(t => t).map(transportOrder => this.renderRow(transportOrder, '1'))}
                    {!!this.props.transportOrders?.length && this.props.paginator?.itemsCount > this.props.paginator?.limit && (
                      <div className="d-flex justify-content-center mt-2 mb-5 mb-md-0">
                        <PaginationComponent paginator={this.props.paginator} selectPage={this.selectPage} />
                      </div>
                    )}
                  </tbody>
                </table>
              )}
            </div>
          ) : (
            <>
              {transportOrdersToShow
                .filter(t => t)
                .map(transportOrder => (
                  <div className="rows">{this.renderCard(transportOrder)}</div>
                ))}
            </>
          ))}

        {/* {!!this.props.transportOrders?.length && this.props.paginator?.itemsCount > this.props.paginator?.limit && (
          <div className="d-flex justify-content-center mt-2">
            <PaginationComponent paginator={this.props.paginator} selectPage={this.selectPage} />
          </div>
        )} */}
        {this.state.showModal && this.state.selectedTransportOrder && (
          <TransportOrderCreateModal
            vehicle={this.state.selectedTransportOrder.vehicle}
            vehicleId={this.state.selectedTransportOrder.vehicleId}
            transportOrderId={this.state.selectedTransportOrder.id}
            overviewButton={true}
            from_location={'overview'}
            forceOpen={true} // Pass a prop to force opening
            onClose={event => this.handleTableRowClick(event, this.state.selectedTransportOrder)}
          />
        )}
      </div>
    );
  }

  renderCard = transportOrder => {
    const establishmentName = "In de Wal Auto's B.V.";
    const vehicle = transportOrder?.vehicle;
    const fromCompany = transportOrder?.companyFrom;
    const fromAddress = transportOrder?.addressFrom;
    const toCompany = transportOrder?.companyTo;
    const toAddress = transportOrder?.addressTo;
    const transporter = transportOrder?.transporter;

    let date =
      typeof vehicle.date_first_allowance === 'number'
        ? dayjs(vehicle.date_first_allowance).format('DD-MM-YYYY')
        : dayjs(vehicle.date_first_allowance, 'DD-MM-YYYY').format('DD-MM-YYYY');
    if (date === 'Invalid Date') {
      date = vehicle.date_first_allowance;
    }
    if (this.props.work) return <LoadingCard />;

    return (
      <CardComponent
        key={vehicle.vehicleId}
        id={`item${vehicle.vehicleId}`}
        vehicle={vehicle}
        onClick={event => this.handleTableRowClick(event, transportOrder)}
        transportOrderPage
        title={
          <div className={s.cardTitle}>
            <div className={s.containerInfo}>
              <span className={s.cardInfoCar}>
                <strong>
                  {transportOrder.vehicleManual}
                  {vehicle?.brand_name}&nbsp;
                  {vehicle?.model_name}
                </strong>
                {/* <span>{vehicle.model_info}</span> */}
                <h6 className={s.gridCardItem}>{<RegplateLabel regplate={vehicle?.regplate} width="80" />}</h6>
                <h6 className={s.gridCardItem}>{vehicle?.vin}</h6>
              </span>

              <div className={s.modelInfo}>
                {/* {this.renderVehiclePaymentStatus(transportOrder?.type, vehicle)} &nbsp; */}
                {/* {this.renderReleaseStatus(transportOrder?.type, vehicle)} */}
              </div>

              <HBox gap={8} className="mt-2">
                <VehicleStatusLabel key={`${transportOrder.id}-${transportOrder.id}`} status={3}>
                  {this.lbl('transport_order.filter.' + transportOrder.type)}
                </VehicleStatusLabel>
                <VehicleStatusLabel key={`${transportOrder.id}`} status={transportOrder.status}>
                  {this.lbl('transport_order.filter.' + transportOrder.status)}
                </VehicleStatusLabel>
              </HBox>
            </div>
            <VBox gap={'8px'} right className={s.containerInfo}>
              <VBox right>
                <strong>{this.lbl('transport_order.overview.column.datePlanned')}</strong>
                <strong>{getDate(transportOrder.datePlanned)}</strong>
              </VBox>
              {/* <VBox right>
                <strong>{this.lbl('transport_order.overview.column.dateToPlan')}</strong>
                <strong>{getDate(transportOrder.dateToPlan)}</strong>
              </VBox> */}
              <VBox right>
                {/* <strong>{this.lbl('transport_order.overview.column.transporter')}</strong> */}
                <strong>{`${transporter?.name || ''} ${transporter?.surname || ''}`}</strong>
              </VBox>
            </VBox>
          </div>
        }
      >
        {/* <div className={cn('text-muted', s.gridCard)}> */}

        <div className="d-flex">
          <div className="card p-3 w-100 cursor-pointer shadow-sm transition-all border-secondary">
            <p className="text-dark fw-medium">
              {' '}
              {transportOrder?.companyFromManual
                ? transportOrder?.companyFromManual
                : fromCompany?.['company_type'] === 'company'
                ? fromCompany?.['name'] || ''
                : `${fromCompany?.name || ''} ${fromCompany?.surname || ''}`}
            </p>
            <p className="text-muted m-0">{fromAddress?.addressLine1}</p>
            <p className="text-muted m-0">
              {fromAddress?.postcode} {fromAddress?.city}
            </p>
            <p>{fromAddress?.country?.name}</p>
            <p className="text-dark fw-medium m-0">{parseCompanyPhoneNumber(fromCompany)}</p>
          </div>
          <div>
            <Right />
          </div>
          <div className="card p-3 w-100 cursor-pointer shadow-sm transition-all border-secondary">
            <p className="text-dark fw-medium">
              {transportOrder?.companyToManual
                ? transportOrder?.companyToManual
                : toCompany['company_type'] === 'company'
                ? toCompany['name'] || ''
                : `${toCompany?.name || ''} ${toCompany?.surname || ''}`}
            </p>
            <p className="text-muted m-0">{toAddress?.addressLine1}</p>
            <p className="text-muted m-0">
              {toAddress?.postcode} {toAddress?.city}
            </p>
            <p className="text-muted m-0">{toAddress?.country?.name}</p>
            <p className="text-dark fw-medium m-0">{parseCompanyPhoneNumber(toCompany)}</p>
          </div>
        </div>
        <div className={s.buttonCard}>
          <strong>{this.lbl('company.details.comment')}</strong> {transportOrder?.remarks}
        </div>
      </CardComponent>
    );
  };

  handleClick(event, itemId) {
    this.to(`/transport-orders/${itemId}`, event?.ctrlKey || event?.metaKey);
  }

  renderText(text) {
    return <strong>{text}</strong>;
  }

  handleTableRowClick = (event, transportOrder) => {
    event?.stopPropagation();
    if (event?.target?.value) return;

    if (this.state.selectedTransportOrder?.id === transportOrder.id) {
      // If clicking the same transport order, close it
      this.setState({ showModal: false, selectedTransportOrder: null });
    } else {
      // Otherwise, open the modal for the new selection
      this.setState({ showModal: true, selectedTransportOrder: transportOrder });
    }
  };

  // handleButtonClick = (event, vehicleId) => {
  //   const excludeElements = ['input', 'img'];
  //   const targetElement = event.target.tagName.toLowerCase();
  //   if (!excludeElements.includes(targetElement)) {
  //     this.handleClick(event, vehicleId);
  //   }
  // };

  // handleButtonClick = (event, transportOrderId) => {
  //   event.stopPropagation();
  //   this.props.history.push(`/vehicles/${transportOrderId}`);
  // };

  handleButtonClick = (event, id) => {
    event.preventDefault();
    if (id) {
      this.props.history.push(`/vehicles/${id}`);
    }
  };

  renderRow(transportOrder) {
    return (
      <tr
        className={`align-middle ${s.thead}`}
        key={transportOrder.id}
        id={`item${transportOrder.id}`}
        onClick={event => this.handleTableRowClick(event, transportOrder)}
      >
        <td className={s.bodyTd}>
          <div className={s.checkboxContainerTd}>
            <CheckboxComponent
              disabled={this.props.weblogin}
              checked={this.isSelectedTransportOrder(transportOrder?.id)}
              onChange={e => this.onSelectTransportOrder(e, transportOrder)}
            />
          </div>
        </td>

        {this.cols().map(col => (
          <td className={s.bodyTd}>
            {this.props.isSplitScreen ? this.renderCell(col, transportOrder) : this.renderCell(col, transportOrder)}
          </td>
        ))}
      </tr>
    );
  }

  renderHeaderCell(col) {
    switch (col) {
      case 'isHome':
        return '';
      default:
        return this.lbl(`transport_order.overview.column.${col}`);
    }
  }

  renderSplitScreenCell(col, transportOrder) {
    const establishmentName = "In de Wal Auto's B.V.";
    const vehicle = transportOrder?.vehicle;
    const fromCompany = transportOrder?.companyFrom;
    const fromAddress = transportOrder?.addressFrom;
    const toCompany = transportOrder?.companyTo;
    const toAddress = transportOrder?.addressTo;
    const transporter = transportOrder?.transporter;

    const key = `${col}-${transportOrder.id}`;

    const fn = () => {
      switch (col) {
        case 'regplate':
          if (transportOrder?.vehicleManual) {
            return '-';
          }
          return (
            <div className={cn('text-wrap', s.reglateCar)} key={key}>
              {vehicle?.regplate ? (
                <div className={s.licensePlate}>
                  <a href={`/vehicles/${vehicle?.id}`} target="_blank" rel="noopener noreferrer">
                    <RegplateLabel regplate={vehicle?.regplate} width="80" />
                  </a>
                </div>
              ) : (
                <div>{vehicle.vin?.substr(-6)}</div>
              )}

              {/* <div>ID: {vehicle.id}</div> */}
            </div>
          );

        case 'info':
          if (transportOrder?.vehicleManual) {
            return <div className={s.brandName}>{transportOrder?.vehicleManual}</div>;
          }
          return (
            <>
              <div className={cn('text-wrap', s.reglateCar)} key={`${key}-col-info`}>
                {vehicle?.regplate ? (
                  <div className={s.licensePlate}>
                    <a href={`/vehicles/${vehicle?.id}`} target="_blank" rel="noopener noreferrer">
                      <RegplateLabel regplate={vehicle?.regplate} width="80" />
                    </a>
                  </div>
                ) : (
                  <div>{vehicle.vin?.substr(-6)}</div>
                )}

                {/* <div>ID: {vehicle.id}</div> */}
              </div>
              <div key={key} className={s.gridContainer}>
                <div className={s.carInformation}>
                  <WithVehicle vehicle_id={transportOrder?.vehicleId}>
                    <div className={s.modelInfo}>
                      {vehicle.brand_name} {vehicle.model_name?.substring(0, 17)}
                    </div>
                    <div className={s.modelName}></div>
                  </WithVehicle>
                </div>
              </div>
            </>
          );
          break;

        case 'financial_info':
          return (
            <VBox className={s.modelInfo} gap={'4px'}>
              {this.renderVehiclePaymentStatus(transportOrder?.type, vehicle)}
              {this.renderReleaseStatus(transportOrder?.type, vehicle)}
            </VBox>
          );

        case 'from_company':
          return (
            <VBox left>
              <VBox className={cn(s.address)} left>
                <strong>
                  {transportOrder?.companyFromManual ||
                    (fromCompany?.['company_type'] === 'company'
                      ? fromCompany?.['name']?.substring(0, 33) || ''
                      : `${fromCompany?.name?.substring(0, 33) || ''} ${fromCompany?.surname?.substring(0, 33) || ''}`)}
                  <br />
                </strong>
                {`${fromAddress?.addressLine1?.substring(0, 17) || ''}, ${fromAddress?.city || ''}`}
              </VBox>
            </VBox>
          );
        case 'from_address':
          if (transportOrder?.addressFromManual) {
            return <>{transportOrder?.addressFromManual}</>;
          }
          return (
            <VBox left>
              <VBox className={cn(s.address)} left>
                <strong>{fromAddress?.addressLine1}</strong>
                <VBox className={cn(s.address)}>
                  {fromAddress?.postcode} {fromAddress?.city}
                </VBox>
                <VBox className={cn(s.address)}>{fromAddress?.country?.name}</VBox>
                <VBox className={cn(s.address)}> {parseCompanyPhoneNumber(fromCompany)}</VBox>
              </VBox>
            </VBox>
          );
        case 'to_company':
          return (
            <>
              <VBox left>
                <VBox className={cn(s.address)} left>
                  <strong>
                    {transportOrder?.companyToManual ||
                      (toCompany?.['company_type'] === 'company'
                        ? toCompany?.['name']?.substring(0, 33) || ''
                        : `${toCompany?.name?.substring(0, 33) || ''} ${toCompany?.surname?.substring(0, 33) || ''}`)}
                    <br />
                  </strong>
                  {`${toAddress?.addressLine1?.substring(0, 17) || ''}, ${toAddress?.city || ''}`}
                </VBox>
              </VBox>
            </>
          );
        case 'to_address':
          if (transportOrder?.addressToManual) {
            return <>{transportOrder?.addressToManual}</>;
          }
          return null;
        case 'transporter':
          return (
            <>
              <VBox className={cn(s.address)} left>{`${transporter?.name || ''}`}</VBox>
            </>
          );
        case 'datePlanned':
          return (
            <VBox gap={8}>
              <VBox className={cn(s.address)} left>
                {getDate(transportOrder.datePlanned)}
              </VBox>
            </VBox>
          );
        case 'dateToPlan':
          return (
            <VBox gap={8}>
              <VBox className={cn(s.address)} left>
                {getDate(transportOrder.dateToPlan)}
              </VBox>
            </VBox>
          );

        case 'direction':
          return (
            <VBox gap={2} className={cn(s.address)} left>
              <VehicleStatusLabel
                key={`${col}-${transportOrder.id}-${transportOrder.id}`}
                status={transportOrder?.type}
                overview={'double'}
              >
                {transportOrder?.type}
              </VehicleStatusLabel>
            </VBox>
          );

        case 'type':
          return (
            <>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
                <VBox gap={2} className={cn(s.address)} left>
                  <VehicleStatusLabel
                    key={`${col}-${transportOrder.id}-${col}`}
                    status={transportOrder?.status}
                    overview={'double'}
                  >
                    {this.lbl(`transport_order.filter.${transportOrder?.status}`)}
                  </VehicleStatusLabel>
                </VBox>

                {transporter?.name && (
                  <VBox gap={2} className={cn(s.address)} center>
                    <VehicleStatusLabel
                      key={`${col}-${transportOrder.id}-${col}`}
                      status={transporter?.name}
                      overview={'double'}
                      color={'black'}
                    >
                      {this.lbl(`transport_order.filter.${transporter?.name}`)}
                    </VehicleStatusLabel>
                    {transportOrder?.datePlanned ? new Date(transportOrder.datePlanned).toLocaleDateString('nl-NL') : ''}
                  </VBox>
                )}
              </div>
            </>
          );

        case 'plan':
          return (
            // <>
            //   <VBox gap={8} onClick={event => event.stopPropagation()} key={`${col}-${transportOrder.id}`}>
            //     <TransportOrderCreateModal
            //       vehicle={transportOrder?.vehicle}
            //       transportOrderId={transportOrder?.id}
            //       overviewButton={true}
            //     />
            //   </VBox>
            // </>
            null
          );

        default:
          return vehicle[col];
      }
    };
    return (
      <div className={`col-${col}`} key={`${col}-${transportOrder.id}`}>
        {fn()}
      </div>
    );
  }

  renderCell(col, transportOrder) {
    const establishmentName = "In de Wal Auto's B.V.";
    const vehicle = transportOrder?.vehicle;
    const vehicleID = transportOrder?.vehicleId;
    const fromCompany = transportOrder?.companyFrom;
    const fromAddress = transportOrder?.addressFrom;
    const toCompany = transportOrder?.companyTo;
    const toAddress = transportOrder?.addressTo;
    const transporter = transportOrder?.transporter;

    const key = `${col}-${transportOrder.id}`;

    const fn = () => {
      switch (col) {
        case 'regplate':
          if (transportOrder?.vehicleManual) {
            return '-';
          }
          return (
            <div className={cn('text-wrap', s.reglateCar)} key={key}>
              <div className={s.licensePlate}>
                <a href={`/vehicles/${vehicleID}`} target="_blank" rel="noopener noreferrer">
                  <RegplateLabel regplate={vehicle?.regplate} width="80" />
                </a>
              </div>
              <div>
                {' '}
                <a href={`/vehicles/${vehicleID}`} target="_blank" rel="noopener noreferrer">
                  {vehicle.vin?.substr(-6)}
                </a>
              </div>
              <div>ID: {vehicleID}</div>
              {/* <HBox left vCenter>
                {this.renderRemarkText(transportOrder?.remarks, transportOrder?.id)}
                {this.renderOpennedTaskAlert(vehicle)}
                {transportOrder?.individual && (
                  <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                    <title>Los transport</title>
                    <circle cx="6" cy="6" r="6" fill="green" />
                  </svg>
                )}
              </HBox> */}
            </div>
          );

        case 'info':
          if (transportOrder?.vehicleManual) {
            return <div className={s.brandName}>{transportOrder?.vehicleManual}</div>;
          }
          return (
            <div key={key} className={s.gridContainer}>
              <div className={s.carInformation}>
                <WithVehicle vehicle_id={transportOrder?.vehicleId}>
                  <div className={s.brandName}>
                    {vehicle.brand_name} {vehicle.model_name} | {vehicle.power ? <>{vehicle.power} Kw</> : ''}
                  </div>
                  <HBox gap={'4px'} flip={window.innerWidth < 1700}>
                    {!transportOrder?.individual && this.renderVehiclePaymentStatus(transportOrder?.type, vehicle)}
                    {!transportOrder?.individual && this.renderReleaseStatus(transportOrder?.type, vehicle)}
                  </HBox>
                </WithVehicle>
              </div>
            </div>
          );
          break;

        case 'from_company':
          return (
            <>
              <strong>
                {transportOrder?.companyFromManual
                  ? transportOrder?.companyFromManual
                  : fromCompany?.['company_type'] === 'company'
                  ? fromCompany?.['name'] || ''
                  : `${fromCompany?.name || ''} ${fromCompany?.surname || ''}`}
              </strong>
              <br />
            </>
          );
        case 'from_address':
          if (transportOrder?.addressFromManual) {
            return <>{transportOrder?.addressFromManual}</>;
          }
          return (
            <VBox left>
              <VBox className="address" left>
                {fromAddress?.addressLine1}
                <div>
                  {fromAddress?.postcode} <strong>{fromAddress?.city}</strong>
                </div>
                <div>{fromAddress?.country?.name}</div>
                <div> {parseCompanyPhoneNumber(fromCompany)}</div>
              </VBox>
            </VBox>
          );
        case 'to_company':
          return (
            <>
              <strong>
                {transportOrder?.companyToManual
                  ? transportOrder?.companyToManual
                  : toCompany['company_type'] === 'company'
                  ? toCompany['name'] || ''
                  : `${toCompany?.name || ''} ${toCompany?.surname || ''}`}
              </strong>
              <br />
            </>
          );
        case 'to_address':
          if (transportOrder?.addressToManual) {
            return <>{transportOrder?.addressToManual}</>;
          }
          return (
            <VBox left>
              <VBox className="address" left>
                {toAddress?.addressLine1}
                <div>
                  {toAddress?.postcode} <strong>{toAddress?.city}</strong>
                </div>
                <div>{toAddress?.country?.name}</div>
                <div> {parseCompanyPhoneNumber(toCompany)}</div>
              </VBox>
            </VBox>
          );
        case 'transporter':
          return <>{`${transporter?.name || ''} ${transporter?.surname || ''}`}</>;
        case 'datePlanned':
          return (
            <VBox gap={8}>
              <div style={{ fontWeight: '600' }}>{getDate(transportOrder.datePlanned)}</div>
            </VBox>
          );
        case 'dateToPlan':
          return (
            <VBox gap={8}>
              <div style={{ fontWeight: '600' }}>{getDate(transportOrder.dateToPlan)}</div>
            </VBox>
          );
        case 'type':
          return (
            <>
              <VBox gap={8}>
                <VehicleStatusLabel
                  overview={'single'}
                  key={`${col}-${transportOrder.id}-${transportOrder.id}`}
                  status={transportOrder.type}
                >
                  {this.lbl('transport_order.filter.' + transportOrder.type)}
                </VehicleStatusLabel>
                <VehicleStatusLabel
                  overview={'single'}
                  key={`${col}-${transportOrder.id}-${col}`}
                  status={transportOrder.status}
                >
                  {this.lbl('transport_order.filter.' + transportOrder.status)}
                </VehicleStatusLabel>
              </VBox>
            </>
          );

        case 'plan':
          return (
            <>
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '1px' }}
                onClick={event => event.stopPropagation()}
                key={`${col}-${transportOrder.id}`}
              >
                <Label count={this.dateDifference(transportOrder)} ranges={ranges}>
                  {this.dateDifference(transportOrder) || '0'}
                </Label>
                {vehicle.location_company_id == '4' ? (
                  <HomeAddressLabel address_id={vehicle.location_address_id} />
                ) : (
                  <span style={{ color: 'rgba(0,0,0, 0.15)' }}>
                    <Home />
                  </span>
                )}
                {this.renderRemarkText(transportOrder?.remarks, transportOrder?.id)}
                {this.renderOpennedTaskAlert(vehicle)}

                {transportOrder?.individual && (
                  <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                    <title>Los transport</title>
                    <circle cx="6" cy="6" r="6" fill="green" />
                  </svg>
                )}
              </div>
            </>
          );

        default:
          return vehicle[col];
      }
    };
    return (
      <div className={`col-${col}`} key={`${col}-${transportOrder.id}`}>
        {fn()}
      </div>
    );
  }
}

TransportOrdersOverviewComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    transportOrders: selectTransportOrders(),
    filter: selectTransportOrderFilter(),
    count: selectTransportOrderCount(),
    paginator: selectTransportOrderPaginator(),
    bulkActionsList: selectTransportOrdersBulkActionsList(),
    doubleScreen: selectOverviewScreenMode(),

    work: selectWorks([REQUEST_TRANSPORT_ORDERS]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch: () => {
      dispatch(changeTransportOrderFilter('searchString', ''));
    },
    changeFilter: (name, value) => {
      dispatch(changeTransportOrderFilter(name, value));
    },

    addTransportOrderToBulkActionsList(transportOrder) {
      dispatch(addTransportOrderToBulkActionsList(transportOrder));
    },
    removeTransportOrderFromBulkActionsList(transportOrderId) {
      dispatch(removeTransportOrderFromBulkActionsList(transportOrderId));
    },
    switchScreen() {
      dispatch(switchOverviewScreenMode());
    },

    setScrollPosition(pos) {
      dispatch(setScrollPosition(pos));
    },
    toggleNotification() {
      dispatch(toggleNotification('0'));
    },
    async setSort(type, order) {
      try {
        const result = await dispatch(setTransportOrdersSort(type, order));
        if (result?.type == SET_TRANSPORT_ORDERS_SORT) {
          dispatch(applyTransportOrderFilters());
        }
      } catch (e) {}
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const TransportOrdersOverview = compose(withConnect, withRouter)(TransportOrdersOverviewComp);
